// import React, { useState } from "react";
// import { Copyright } from "lucide-react";
// import "./footer_sec.css";
// import wikilogo2 from "../../img/des_sec/Wikiworks logo SVG 2.svg"; // Replace with your actual logo path
// import linkedin from "../../img/des_sec/linkedin.svg"; // Replace with your actual logo path

// const FooterSec = () => {
//   const [email, setEmail] = useState("");

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log("Subscribed with:", email);
//     setEmail("");
//   };

//   return (
//     <footer className="footer-container-fo">
//       <div className="footer-wave-background-fo"></div>

//       <div className="footer-content-fo">
//         {/* Logo section */}
//         <div className="logo-section-fo">
//           <div className="logo-image-container-fo">
//             <img
//               src={wikilogo2}
//               alt="WikiWorks Logo"
//               className="logo-image-fo"
//             />
//           </div>
//         </div>

//         {/* Three column section */}
//         <div className="footer-columns-fo">
//           {/* Address column */}
//           <div className="footer-column-fo">
//             <h3 className="column-title-fo">Address</h3>
//             <p className="address-text-fo">
//               WikiWorks Technologies
//               <br />
//               Private Limited. 4th Floor,
//               <br />
//               #307, 5th A Cross, HRBR
//               <br />
//               Layout, Bengaluru - 560043
//             </p>
//           </div>

//           {/* Contact details column */}
//           <div className="footer-column-fo">
//             <h3 className="column-title-fo">Contact details</h3>
//             <div className="contact-item-fo">
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 className="contact-icon-fo"
//                 fill="none"
//                 viewBox="0 0 24 24"
//                 stroke="currentColor"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
//                 />
//               </svg>
//               <a href="mailto:sales@wikiworks.in" className="contact-link-fo">
//                 sales@wikiworks.in
//               </a>
//             </div>
//             <div className="contact-item-fo">
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 className="contact-icon-fo"
//                 fill="none"
//                 viewBox="0 0 24 24"
//                 stroke="currentColor"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
//                 />
//               </svg>
//               <a href="tel:+919036660905" className="contact-link-fo">
//                 +91-9036660905
//               </a>
//             </div>
//           </div>

//           {/* Newsletter column */}
//           <div className="footer-column-fo">
//             <h3 className="column-title-fo">Newsletter</h3>
//             <form onSubmit={handleSubmit} className="newsletter-form-fo">
//               <input
//                 type="email"
//                 placeholder="email@newsletter.com"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 className="newsletter-input-fo"
//                 required
//               />
//               <button type="submit" className="subscribe-button-fo">
//                 Subscribe
//               </button>
//             </form>
//           </div>
//         </div>

//         {/* Copyright and social media */}
//         <div className="footer-bottom-fo">
//           <div className="copyright-fo">
//             <span className="copyright-text-fo">
//             <Copyright />
//                <span> &nbsp;</span>Copyright. All rights reserved.
//             </span>
//           </div>
//           <div className="social-media-fo">
//             <span className="follow-text-fo">Follow Us on</span>
//             <a href="https://linkedin.com" className="social-link-fo">
//               <img 
//                 src={linkedin} 
//                 alt="LinkedIn" 
//                 className="social-icon-fo" 
//               />
//             </a>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default FooterSec;

import React, { useState, useRef, useEffect } from "react";
import { useSpring, animated } from 'react-spring';
import { Copyright } from "lucide-react";
import "./footer_sec.css";
import wikilogo2 from "../../img/des_sec/Wikiworks logo SVG 2.svg"; // Replace with your actual logo path
import linkedin from "../../img/des_sec/linkedin.svg"; // Replace with your actual logo path
import admin from "../../img/des_sec/setting.svg"; // Replace with your actual logo path

const FooterSec = () => {
  const [email, setEmail] = useState("");
  const [inView, setInView] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
        } else {
          setInView(false);
        }
      },
      {
        threshold: 0.1,
        rootMargin: '-30px 0px'
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Subscribed with:", email);
    setEmail("");
  };

  // Animation for logo section
  const logoAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(15px)',
    config: { 
      tension: 180, 
      friction: 35,
      mass: 1
    },
    delay: inView ? 100 : 0
  });

  // Animation for address column
  const addressAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(12px)',
    config: { 
      tension: 160, 
      friction: 30,
      mass: 1
    },
    delay: inView ? 200 : 0
  });

  // Animation for contact column
  const contactAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(12px)',
    config: { 
      tension: 160, 
      friction: 30,
      mass: 1
    },
    delay: inView ? 350 : 0
  });

  // Animation for newsletter column
  const newsletterAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(12px)',
    config: { 
      tension: 160, 
      friction: 30,
      mass: 1
    },
    delay: inView ? 500 : 0
  });

  // Animation for footer bottom section
  const footerBottomAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(10px)',
    config: { 
      tension: 150, 
      friction: 25,
      mass: 0.8
    },
    delay: inView ? 650 : 0
  });

  return (
    <footer className="footer-container-fo" ref={containerRef}>
      <div className="footer-wave-background-fo"></div>

      <div className="footer-content-fo">
        {/* Logo section */}
        <animated.div 
          className="logo-section-fo"
          style={{
            ...logoAnimation,
            position: 'relative',
            zIndex: 1
          }}
        >
          <div className="logo-image-container-fo">
            <img
              src={wikilogo2}
              alt="WikiWorks Logo"
              className="logo-image-fo"
            />
          </div>
        </animated.div>

        {/* Three column section */}
        <div className="footer-columns-fo">
          {/* Address column */}
          <animated.div 
            className="footer-column-fo"
            style={{
              ...addressAnimation,
              position: 'relative',
              zIndex: 1
            }}
          >
            <h3 className="column-title-fo">Address</h3>
            <p className="address-text-fo">
              WikiWorks Technologies
              <br />
              Private Limited. 4th Floor,
              <br />
              #307, 5th A Cross, HRBR
              <br />
              Layout, Bengaluru - 560043
            </p>
          </animated.div>

          {/* Contact details column */}
          <animated.div 
            className="footer-column-fo"
            style={{
              ...contactAnimation,
              position: 'relative',
              zIndex: 1
            }}
          >
            <h3 className="column-title-fo">Contact details</h3>
            <div className="contact-item-fo">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="contact-icon-fo"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
              <a href="mailto:sales@wikiworks.in" className="contact-link-fo">
                sales@wikiworks.in
              </a>
            </div>
            <div className="contact-item-fo">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="contact-icon-fo"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                />
              </svg>
              <a href="tel:+919036660905" className="contact-link-fo">
                +91-9036660905
              </a>
            </div>
          </animated.div>

          {/* Newsletter column */}
          <animated.div 
            className="footer-column-fo"
            style={{
              ...newsletterAnimation,
              position: 'relative',
              zIndex: 1
            }}
          >
            <h3 className="column-title-fo">Newsletter</h3>
            <form onSubmit={handleSubmit} className="newsletter-form-fo">
              <input
                type="email"
                placeholder="email@newsletter.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="newsletter-input-fo"
                required
              />
              <button type="submit" className="subscribe-button-fo">
                Subscribe
              </button>
            </form>
          </animated.div>
        </div>

        {/* Copyright and social media */}
        <animated.div 
          className="footer-bottom-fo"
          style={{
            ...footerBottomAnimation,
            position: 'relative',
            zIndex: 1
          }}
        >
          <div className="copyright-fo">
            <span className="copyright-text-fo">
            <Copyright />
               <span> &nbsp;</span>Copyright. All rights reserved.
            </span>
          </div>
          <div className="social-media-fo">
            <span className="follow-text-fo">Follow Us on</span>
            <a href="https://www.linkedin.com/company/wikiworks-technologies/?originalSubdomain=in" className="social-link-fo">
              <img 
                src={linkedin} 
                alt="LinkedIn" 
                className="social-icon-fo" 
              />
            </a>
            &nbsp;&nbsp;
            <a href="/adminLogin" className="social-link-fo">
              <img 
                src={admin} 
                alt="LinkedIn" 
                className="social-icon-fo" 
              />
            </a>
          </div>
        </animated.div>
      </div>
    </footer>
  );
};

export default FooterSec;
